// extracted by mini-css-extract-plugin
module.exports = {"FAQs":"FAQs_FAQs__h55Eg","FAQs__title":"FAQs_FAQs__title__L1kBI","FAQs__item":"FAQs_FAQs__item__gb_SW","fadeInKeyframe":"FAQs_fadeInKeyframe__xJv1b"};